
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
} from "@ionic/vue";

import Information from "@/components/Information.vue";

export default {
  name: "Tab3",
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage, Information },
};
